import { CancelBtn } from 'components/Button/CancelBtn'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { NavBar } from 'components/NavBar/NavBar'
import { ISelectValue } from 'constants/globalTypes'
import { addPolicy } from 'features/attendance/attendanceSlice'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { AppDispatch } from 'store'
import { Button, Flex, H1WithBack, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { BodyText, OtherText, TitleText } from 'styling/Typography'

export const AddPolicy = () => {
    const [state, setState] = useState<IAttendancePolicyState>({
        name: '',
        description: '',
        workflowSteps: [{
            id: new Date().getTime(),
            name: '',
            order: 1,
            resolverType: { label: 'Role', value: 1 },
            roles: [],
            users: [],
        }]
    })

    const [selectedRole, setSelectedRole] = useState<ISelectValue | null>(null)
    const [selectedUser, setSelectedUser] = useState<ISelectValue | null>(null)
    const navigate = useNavigate()

    const dispatch = useDispatch<AppDispatch>()

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const handleWorkflowStepChange = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {
        const { value, name } = e.target
        setState(prev => {
            const workflowSteps = [...prev.workflowSteps]
            const stepIndex = workflowSteps.findIndex(s => s.id === id)
            if (stepIndex === -1) return prev
            workflowSteps[stepIndex] = { ...workflowSteps[stepIndex], [name]: value }
            return { ...prev, workflowSteps }
        })
    }

    const handleWorkflowStepSelect = (e: ISelectValue, id: number) => {
        setState(prev => {
            const workflowSteps = [...prev.workflowSteps]
            const stepIndex = workflowSteps.findIndex(s => s.id === id)
            if (stepIndex === -1) return prev
            workflowSteps[stepIndex] = { ...workflowSteps[stepIndex], resolverType: e }
            return { ...prev, workflowSteps }
        })
    }

    const handleAddUser = (stepId: number) => {
        if (!selectedUser) return
        setState(prev => {
            const workflowSteps = [...prev.workflowSteps]
            const stepIndex = workflowSteps.findIndex(s => s.id === stepId)
            if (stepIndex === -1) return prev
            const users = workflowSteps[stepIndex].users || []
            workflowSteps[stepIndex] = { ...workflowSteps[stepIndex], users: [...users, selectedUser] }
            return { ...prev, workflowSteps }
        })
        setSelectedUser(null)
    }

    const handleAddRole = (stepId: number) => {
        if (!selectedRole) return
        setState(prev => {
            const workflowSteps = [...prev.workflowSteps]
            const stepIndex = workflowSteps.findIndex(s => s.id === stepId)
            if (stepIndex === -1) return prev
            const roles = workflowSteps[stepIndex].roles || []
            workflowSteps[stepIndex] = { ...workflowSteps[stepIndex], roles: [...roles, selectedRole] }
            return { ...prev, workflowSteps }
        })
        setSelectedRole(null)
    }


    const parseRoles = (data: any) => {
        return data.data.map((item: any) => ({ label: item.name, value: item.id }))
    }

    const handleAddStep = () => {
        setState(prev => {
            const workflowSteps = [...prev.workflowSteps]
            workflowSteps.push({
                id: new Date().getTime(),
                name: '',
                order: workflowSteps.length + 1,
                resolverType: { label: 'Role', value: 1 },
                roles: [],
                users: [],
            })
            return { ...prev, workflowSteps }
        })
    }

    const handleSubmit = async () => {
        const resp = await dispatch(addPolicy(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            navigate(-1)
        }
    }

    return <>
        <NavBar />
        <PageWrapper>
            <H1WithBack arrow title='Add Policy' />
            <Flex width='100%' between mt='16' gap='5rem' >
                <Flex column gap='1rem' width='100%'>
                    <Input placeholder='General Policy' labelText='Name' name='name' nomarg value={state.name} onChange={handleChange} />
                    <Input placeholder='Policy Description' labelText='Description' name='description' nomarg value={state.description} onChange={handleChange} />
                </Flex>
                <Flex column gap='1rem' width='100%'>
                    <TitleText weight='bold' >Workflow Steps</TitleText>
                    {state.workflowSteps.map(s => <Flex key={s.order} column gap='0.5rem' >

                        <Input labelText="Name" placeholder="First step..." name='name' value={s.name} onChange={(e) => handleWorkflowStepChange(e, s.id)} />
                        <HonestSelectInput labelText='Resolver Type' options={resolverTypeOptions} name='resolverType' defaultValue={s.resolverType.value} onChange={(e: ISelectValue) => handleWorkflowStepSelect(e, s.id)} />
                        <Flex gap='1rem' alignEnd>
                            <HonestSelectAsyncInput
                                nomarg
                                link='users/basic'
                                name='employee'
                                labelText='Employee'
                                onChange={(v) => setSelectedUser({ ...v })}
                                parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.fullName, profilePictureUrl: i.getImagePresignedUrl, value: i.id, id: i.accessCardId, role: i.role, gender: i.gender, tierPolicy: i.currentContract?.logisticsInfo?.accomodationTierPolicy }))}
                            />
                            <Button orange onClick={() => handleAddUser(s.id)}>Add</Button>
                        </Flex>

                        <Flex gap='1rem' alignEnd >
                            <HonestSelectAsyncInput
                                link='roles'
                                placeholder='Search role'
                                name='roleId'
                                labelText='Role'
                                onChange={(v) => setSelectedRole({ ...v })}
                                parserFunction={parseRoles}
                                nomarg
                            />
                            <Button orange onClick={() => handleAddRole(s.id)}>Add</Button>
                        </Flex>
                        <Flex gap='1rem' >
                            <Flex column gap='0.5rem' >
                                <TitleText>Employees</TitleText>
                                {s.users.length ? s.users.map(u => <BodyText key={u.value} >{u.label}</BodyText>) : <OtherText grey>No employees added</OtherText>}
                            </Flex>
                            <Flex column gap='0.5rem' >
                                <TitleText>Roles</TitleText>
                                {s.roles.length ? s.roles.map(r => <BodyText key={r.value} >{r.label}</BodyText>) : <OtherText grey>No roles added</OtherText>}
                            </Flex>
                        </Flex>
                    </Flex>)}
                    <Button orange onClick={handleAddStep} >Add Step</Button>
                </Flex>

            </Flex>
            <PageFooter>
                <Flex width='100%' end='true'>
                    <CancelBtn />
                    <Button ml='15' height='40' orange onClick={handleSubmit}>
                        Save
                    </Button>
                </Flex>
            </PageFooter>
        </PageWrapper>
    </>
}

export interface IAttendancePolicyState {
    name: string
    description: string
    workflowSteps: {
        id?: number
        order: number
        name: string
        resolverType: ISelectValue
        roles: ISelectValue[]
        users: ISelectValue[]
    }[]
}

export const resolverTypeOptions = [
    { label: 'Role', value: 1 },
    { label: 'User', value: 2 },
]